import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CrmIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_1518_54207)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.8333 12.673V15.173L14.8333 12.673H16.8333C17.0985 12.673 17.3529 12.5677 17.5404 12.3802C17.7279 12.1926 17.8333 11.9382 17.8333 11.673V3.67303C17.8333 3.40782 17.7279 3.15346 17.5404 2.96593C17.3529 2.77839 17.0985 2.67303 16.8333 2.67303H8.83325C8.56804 2.67303 8.31368 2.77839 8.12615 2.96593C7.93861 3.15346 7.83325 3.40782 7.83325 3.67303",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.98389 8.38837C2.80415 9.23838 3.86385 9.81838 5.02193 10.0512C6.18 10.284 7.38152 10.1586 8.46659 9.69171",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.49976 10.168C1.49976 11.0962 1.8685 11.9864 2.52488 12.6428C3.18126 13.2992 4.0715 13.668 4.99976 13.668C5.92802 13.668 6.81825 13.2992 7.47463 12.6428C8.13102 11.9864 8.49976 11.0962 8.49976 10.168C8.49976 9.2397 8.13102 8.34948 7.47463 7.6931C6.81825 7.03672 5.92802 6.66797 4.99976 6.66797C4.0715 6.66797 3.18126 7.03672 2.52488 7.6931C1.8685 8.34948 1.49976 9.2397 1.49976 10.168Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.1164 17.6691C9.12289 16.3927 7.68802 15.534 6.09364 15.2616C4.49926 14.9893 2.86065 15.3229 1.49976 16.1971",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.6667 9.99524H10.3334",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14.9998 5.33551H12.8664V10.0022H14.9998V5.33551Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.8674 7.04608H10.7341V10.0016H12.8674V7.04608Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1518_54207",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "16",
                        fill: "white",
                        transform: "translate(1 2)"
                    })
                })
            })
        ]
    });
